export const RESUMEN_MOCK = {
  zipiMessage: 'Hola Jose, <strong>tus ventas de hoy llevan $187.450</strong> — vas 12% arriba que el martes pasado. Tu producto más vendido es Coca-Cola 1,5L.',

  kpis: {
    ventasHoy: {
      value: '$187.450',
      delta: '+12% vs ayer',
      deltaType: 'up',
      sub: '43 boletas · último pago hace 8 min',
    },
    esteMes: {
      value: '$3.241.900',
      delta: '+8% vs marzo pasado',
      deltaType: 'up',
      progress: 81,
      meta: '$4.000.000',
    },
    alertasStock: {
      value: 5,
      sinStock: 2,
      bajoMinimo: 3,
    },
    margen: {
      value: '22%',
      delta: '≈ $41.200 neto',
      deltaType: 'neutral',
      sub: 'Promedio 7 días: 19%',
    },
  },

  topProductos: [
    {
      rank: 1, name: 'Coca-Cola 1,5L retornable', amount: '$34.200', units: '18 un.', pct: 100,
    },
    {
      rank: 2, name: 'Aceite Vegetal 1L', amount: '$26.100', units: '9 un.', pct: 76,
    },
    {
      rank: 3, name: 'Nescafé Clásico 200g', amount: '$20.900', units: '5 un.', pct: 61,
    },
    {
      rank: 4, name: 'Leche Colún 1L', amount: '$16.400', units: '8 un.', pct: 48,
    },
    {
      rank: 5, name: 'Fideos Carozzi 500g', amount: '$11.900', units: '7 un.', pct: 35,
    },
  ],

  ventasSemana: [
    { day: 'Jue', amount: 145000, isToday: false },
    { day: 'Vie', amount: 204000, isToday: false },
    { day: 'Sáb', amount: 243000, isToday: false },
    { day: 'Dom', amount: 95000, isToday: false },
    { day: 'Lun', amount: 171000, isToday: false },
    { day: 'Mar', amount: 143000, isToday: false },
    { day: 'Hoy', amount: 187450, isToday: true },
  ],

  ventasPorLocal: [
    {
      storeId: 1, name: 'Local Centro', amount: 87400, orders: 21,
    },
    {
      storeId: 2, name: 'Local Norte', amount: 62100, orders: 15,
    },
    {
      storeId: 3, name: 'Local Sur', amount: 37950, orders: 9,
    },
  ],

  pagos: [
    {
      icon: '💳', label: 'Tarjeta débito', pct: '58%', val: '$108.720', bg: '#EFF9FF',
    },
    {
      icon: '💵', label: 'Efectivo', pct: '32%', val: '$59.980', bg: '#FFF5EE',
    },
    {
      icon: '💳', label: 'Tarjeta crédito', pct: '10%', val: '$18.750', bg: '#F0FAF9',
    },
  ],
};

export const PERIODS = [
  { key: 'today', label: 'Hoy' },
  { key: 'yesterday', label: 'Ayer' },
  { key: '7d', label: '7d' },
  { key: '30d', label: '30d' },
  { key: '90d', label: '90d' },
];

export const PERIOD_SUFFIX = {
  today: 'hoy',
  yesterday: 'ayer',
  '7d': 'últimos 7 días',
  '30d': 'últimos 30 días',
  '90d': 'últimos 90 días',
};

export function getDateRange(period) {
  const now = new Date();
  const sod = (d) => new Date(d.getFullYear(), d.getMonth(), d.getDate());
  const eod = (d) => new Date(d.getFullYear(), d.getMonth(), d.getDate(), 23, 59, 59);
  switch (period) {
    case 'yesterday': {
      const y = new Date(now);
      y.setDate(now.getDate() - 1);
      return { startDate: sod(y), endDate: eod(y) };
    }
    case '7d': {
      const s = new Date(now);
      s.setDate(now.getDate() - 6);
      return { startDate: sod(s), endDate: eod(now) };
    }
    case '30d': {
      const s = new Date(now);
      s.setDate(now.getDate() - 29);
      return { startDate: sod(s), endDate: eod(now) };
    }
    case '90d': {
      const s = new Date(now);
      s.setDate(now.getDate() - 89);
      return { startDate: sod(s), endDate: eod(now) };
    }
    default:
      return { startDate: sod(now), endDate: eod(now) };
  }
}

export const COLORS = {
  blue: '#33B1E1',
  blueDk: '#1E8FBA',
  orange: '#FE7C16',
  ink: '#10253C',
  slate: '#3F6372',
  mist: '#E7EEF3',
  success: '#21AA9D',
  warning: '#C47A2C',
  danger: '#E05252',
};
